export default {
  title: 'Datum en tijd',
  buttons: {
    done: 'Klaar',
  },
};
